// Editor row shape: { item, link, amount }
// (amount is the raw <input> string so partial typing is preserved).

const str = (v) => String(v ?? '');
const isFilled = (r) => [r.item, r.link, r.amount].some((v) => str(v).trim() !== '');

export function cleanExpenseItems(items) {
  return (items || []).filter(isFilled);
}

export function expenseTotal(items) {
  return cleanExpenseItems(items).reduce((sum, r) => {
    const n = parseFloat(r.amount);
    return sum + (Number.isFinite(n) ? n : 0);
  }, 0);
}

// Null if every filled row is complete (Link optional), else a user-facing message.
export function expenseItemsError(items) {
  const rows = cleanExpenseItems(items);
  for (let i = 0; i < rows.length; i++) {
    const r = rows[i];
    const n = i + 1;
    if (!str(r.item).trim()) return `Expense row ${n}: Item is required.`;
    const amt = parseFloat(r.amount);
    if (!Number.isFinite(amt) || amt < 0) return `Expense row ${n}: Amount must be a number ≥ 0.`;
  }
  return null;
}

export function toExpenseDbRows(items) {
  return cleanExpenseItems(items).map((r) => ({
    item: str(r.item).trim(),
    link: str(r.link).trim() || null,
    amount: parseFloat(r.amount),
  }));
}

export function fromExpenseDbRows(rows) {
  return [...(rows || [])]
    .sort((a, b) => (a.position ?? 0) - (b.position ?? 0))
    .map((r) => ({
      item: r.item ?? '',
      link: r.link ?? '',
      amount: r.amount == null ? '' : String(r.amount),
    }));
}
